import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

export const linerTypeApiSchema = v.object({
  codeDesc: v.string(),
  codeId: v.string(),
  id: v.number(),
  lookupCodeType: v.string(),
});

export const linerTypeSchema = v.object({
  ...linerTypeApiSchema.entries,
  ...optionSchema.entries,
});

export const linerTypesApiSchema = paginatedSchema(linerTypeApiSchema);

export type LinerTypeApi = v.InferOutput<typeof linerTypeApiSchema>;
export type LinerTypesApi = v.InferOutput<typeof linerTypesApiSchema>;

export type LinerTypeFilters = Filters<LinerTypeApi>;

export type LinerTypeFiltersUpdateApi = FiltersUpdateApi<LinerTypeApi>;

export type LinerType = Prettify<Option<v.InferOutput<typeof linerTypeSchema>>>;

export type LinerTypes = Entities<LinerType>;
